/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "peoplePortalRestAPI",
            "endpoint": "https://fpww6hr46g.execute-api.eu-west-2.amazonaws.com/production",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:02bb95a2-0282-4e5c-a1da-e51c9bd41d01",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_NOGEI9Qdo",
    "aws_user_pools_web_client_id": "j2nunff7hd0p2tbcc42p8eurt",
    "oauth": {
        "domain": "agentoslive.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/api/auth/callback/cognito,http://localhost:3000/api/auth/oauth2/callback/cognito,http://localhost:5173/,https://automations.agentos.com/api/auth/oauth2/callback/cognito,https://d84l1y8p4kdic.cloudfront.net,https://docshelper.agentos.com/api/auth/callback/cognito,https://localhost:3000/api/auth/callback/cognito,https://main.d1eci1svxix9cy.amplifyapp.com/",
        "redirectSignOut": "http://localhost:3000,http://localhost:5173/,https://main.d1eci1svxix9cy.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 9,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
